module.exports = __webpack_public_path__ + "static/media/questionnaire-step4.6f97cd1d.png";